import React, { useRef, useEffect, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Carrito from '../ecommerce/Carrito'
import { getPedidoActivo } from '../../actions/pedidos'
import { getTiras } from '../../actions/tiras'
import { getOfertas } from '../../actions/ofertas'
import { getNovedades } from '../../actions/novedades'
import { ordenarMenu, programaActivo } from '../../helpers/funciones'
import LanguageSelector from './LanguageSelector'
import { getMenus } from '../../actions/portal'
import { ShoppingCart, SignOut, User, X, Files, Info, UserSwitch } from 'phosphor-react'
import i18n from '../../lang/idiomas'
import { getListasCompra } from '../../actions/listasCompra'
import SelectorCliente from '../usuarios/SelectorCliente'
import { obtenerValorParametro } from '../../helpers/funciones'

let menusMostrar = []

const Header = props => {
  const dispatch = useDispatch()

  const auth = useSelector(state => state.auth)
  const pedido = useSelector(state => state.pedidos.pedido)
  const portal = useSelector(state => state.portal.portal)
  const menus = useSelector(state => state.portal.menus)
  const cookies = useSelector(state => state.portal.cookies)
  const id_pedido_seleccionado = useSelector(state => state.pedidos.id_pedido_seleccionado)
  const ofertas = useSelector(state => state.listadoArticulos.ofertas)
  const novedades = useSelector(state => state.listadoArticulos.novedades)
  const language = useSelector(state => state.languageSelector.language)
  const clientesPermitidos = useSelector(state => state.auth.user.clientes_permitidos)
  const clienteSeleccionado = useSelector(state => state.selectorCliente.cliente_seleccionado)
  const ecomParametros = useSelector(state => state.portal.portal.parametros_ecom)

  const prevProps = useRef()

  useEffect(() => {
    dispatch(getMenus())
    if (typeof window.wookie !== undefined) {
      window.wookie()
    } else {
      console.log('No se encuentra librería wookie')
    }
  }, [auth.isAuthenticated, language])

  useEffect(() => {
    if (menus?.length > 0 && portal.descripcion) {
      // Si existe el menu novedadesOfertas
      if (programaActivo(menus, 'novedadesOfertas')) {
        if (ofertas.articulos === undefined) {
          dispatch(getOfertas())
        }

        if (novedades.articulos === undefined) {
          dispatch(getNovedades())
        }
      }

      // Si existen articulos recuperamos pedido y tiras
      const p_auto_crear_pedido = obtenerValorParametro(ecomParametros, 'AUTO_CREAR_PEDIDO', 'GEN')

      if (programaActivo(menus, 'articulos')) {
        dispatch(
          getPedidoActivo(
            auth.hash != null ? auth.hash : '',
            'N',
            id_pedido_seleccionado,
            p_auto_crear_pedido,
          ),
        )
        dispatch(getTiras())
      }

      if (programaActivo(menus, 'articulosListItems')) {
        dispatch(
          getPedidoActivo(
            auth.hash != null ? auth.hash : '',
            'N',
            id_pedido_seleccionado,
            p_auto_crear_pedido,
          ),
        )
        dispatch(getTiras())
      }

      if (programaActivo(menus, 'novedadesOfertas')) {
        dispatch(
          getPedidoActivo(
            auth.hash != null ? auth.hash : '',
            'N',
            id_pedido_seleccionado,
            p_auto_crear_pedido,
          ),
        )
        dispatch(getTiras())
      }

      // Si existen listasCompra las solicitamos
      if (programaActivo(menus, 'listasCompra')) {
        dispatch(getListasCompra())
      }
    }
  }, [portal, menus])

  const ocultarMenu = e => {
    document.getElementsByClassName('mobile-main-menu')[0].classList.remove('mmitemopen')
  }

  const cargarIcono = menu => {
    if (menu.programa) {
      switch (menu.programa) {
        case 'login':
          return (
            <User
              size={22}
              weight='regular'
            />
          )
        case 'informes':
          return (
            <Files
              size={22}
              weight='regular'
            />
          )
        case 'contacto':
          return (
            <Info
              size={22}
              weight='regular'
            />
          )
        case 'cuenta':
          return (
            <User
              size={20}
              weight='fill'
            />
          )
        case 'logout':
          return (
            <SignOut
              size={20}
              weight='fill'
            />
          )
        case 'selectorCliente':
          return (
            <UserSwitch
              size={22}
              weight='fill'
            />
          )
        default:
          return ''
      }
    } else if (menu.nombre) {
      switch (menu.nombre) {
        case 'USUARIO':
          return (
            <User
              size={22}
              weight='regular'
            />
          )
        case 'CARRITO':
          return (
            <ShoppingCart
              size={22}
              weight='regular'
            />
          )
        case 'SELECTOR_CLIENTE':
          return (
            <UserSwitch
              size={22}
              weight='regular'
            />
          )
        default:
          return ''
      }
    }
  }

  const { isAuthenticated, user } = auth
  const { lineas } = pedido
  let ofertaAT = ofertas.articulos_total
  let novedadAT = novedades.articulos_total
  const invitado = auth.invitado

  menusMostrar = menus
  if (menusMostrar && menusMostrar.length > 0) {
    menusMostrar = menusMostrar.sort(ordenarMenu)
    if (auth.isAuthenticated && !invitado) {
      menusMostrar = menusMostrar.filter(menu => {
        return menu.programa !== 'login' && menu.programa !== 'registro'
      })
    }
    if (auth.user && auth.user.puede_crear_usuarios !== 'S') {
      menusMostrar = menusMostrar.filter(menu => {
        return menu.programa !== 'registroHijos'
      })
    }
  }
  const retornarMenu = (menu, origen) => {
    if (menu?.programa?.substring(0, 4) === 'http') {
      return (
        <a href={menu.programa}>
          {menu.icono ? cargarIcono(menu) : ''}
          {menu.nombre}
        </a>
      )
    } else if (menu.programa === null && menu?.hijos?.length > 0) {
      return (
        <Link
          to={
            '/' + menu.hijos[0].programa + (menu.hijos[0].camino ? '/' + menu.hijos[0].camino : '')
          }>
          {menu.icono ? cargarIcono(menu) : ''}
          {menu.nombre}
        </Link>
      )
    } else {
      return (
        <Link
          onClick={origen === 'mobile' ? ocultarMenu : null}
          to={'/' + menu.programa + (menu.camino ? '/' + menu.camino : '')}>
          {menu.icono ? cargarIcono(menu) : ''}
          {menu.nombre}
        </Link>
      )
    }
  }

  const retornarHijos = (menu, origen) => {
    return menu.hijos.map(hijo => {
      return hijo.visible === 'S' ? (
        <li key={hijo.id}>
          <Link
            onClick={origen === 'mobile' ? ocultarMenu : null}
            to={'/' + hijo.programa + (hijo.camino ? '/' + hijo.camino : '')}>
            {hijo.nombre}
          </Link>
        </li>
      ) : (
        ''
      )
    })
  }

  const desktoLinks = (
    <div className='tt-obj-menu'>
      <div className='container'>
        <div className='row justify-content-md-end no-gutters'>
          <div className='tt-desctop-parent-menu tt-parent-box'>
            <div className='tt-desctop-menu'>
              <nav>
                <ul>
                  {menusMostrar && menusMostrar.length > 0
                    ? menusMostrar.map(menu => {
                        menu.hijos.sort(ordenarMenu)
                        return menu.visible === 'S' &&
                          menu.objeto_programa !== 'CARRITO' &&
                          menu.objeto_programa !== 'USUARIO' &&
                          menu.objeto_programa !== 'SELECTOR_CLIENTE' ? (
                          <li
                            key={menu.id}
                            className='dropdown  tt-megamenu-col-01'>
                            {retornarMenu(menu, 'desktop')}
                            {menu.programa === 'novedadesOfertas' &&
                            ofertaAT &&
                            novedadAT &&
                            (ofertaAT !== 0 || novedadAT !== 0) ? (
                              <span className='tt-badge-news'>
                                {ofertaAT !== 0 || novedadAT !== 0 ? ofertaAT + novedadAT : ''}
                              </span>
                            ) : (
                              ''
                            )}
                            {menu.hijos.length > 0 ? (
                              <Fragment>
                                <div className='dropdown-menu'>
                                  <div className='row tt-col-list'>
                                    <div className='col'>
                                      <ul className='tt-megamenu-submenu'>
                                        {retornarHijos(menu, 'desktop')}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </Fragment>
                            ) : (
                              ''
                            )}
                          </li>
                        ) : (
                          ''
                        )
                      })
                    : ''}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  const mobileMenu = (
    <ul className='menu-mobile'>
      {menusMostrar && menusMostrar.length > 0
        ? menusMostrar.map(menu => {
            menu.hijos.sort(ordenarMenu)
            return menu.visible === 'S' &&
              menu.objeto_programa !== 'CARRITO' &&
              menu.objeto_programa !== 'USUARIO' &&
              menu.objeto_programa !== 'SELECTOR_CLIENTE' ? (
              <li key={menu.id}>
                {retornarMenu(menu, 'mobile')}
                {menu.hijos.length > 0 ? <ul>{retornarHijos(menu, 'mobile')}</ul> : ''}
              </li>
            ) : (
              ''
            )
          })
        : ''}
    </ul>
  )

  const desktopAuthObjects = (
    <div className='tt-obj-options obj-move-right'>
      {menusMostrar && menusMostrar.length > 0
        ? menusMostrar.map(menu => {
            return menu.visible === 'S' &&
              menu.objeto_programa === 'SELECTOR_CLIENTE' &&
              clientesPermitidos !== undefined &&
              clientesPermitidos.length > 1 ? (
              <div
                key='boton_selector_cliente'
                className='tt-desctop-parent-client-select tt-parent-box'>
                <div
                  className='tt-client-select tt-dropdown-obj'
                  data-tposition='bottom'>
                  <button className='tt-dropdown-toggle select-cambio-cliente'>
                    {menu.icono ? cargarIcono(menu) : ''}
                    <small>
                      {isAuthenticated
                        ? clientesPermitidos.filter(cliente => {
                            return clienteSeleccionado === ''
                              ? cliente.codigo_cliente === user.codigo_cliente
                              : cliente.id === clienteSeleccionado
                          })[0].nombre
                        : ''}
                    </small>
                  </button>
                  <SelectorCliente />
                </div>
              </div>
            ) : (
              ''
            )
          })
        : ''}
      {menusMostrar && menusMostrar.length > 0
        ? menusMostrar.map(menu => {
            return menu.visible === 'S' && menu.objeto_programa === 'CARRITO' ? (
              <div
                key='boton_carrito'
                className='tt-desctop-parent-cart tt-parent-box'>
                <div
                  className='tt-cart tt-dropdown-obj'
                  //data-tooltip="Carrito"
                  data-tposition='bottom'>
                  <button className='tt-dropdown-toggle'>
                    {menu.icono ? cargarIcono(menu) : ''}
                    <span className='tt-badge-cart'>{lineas ? lineas.length : '0'}</span>
                  </button>
                  <Carrito />
                </div>
              </div>
            ) : (
              ''
            )
          })
        : ''}
      {menusMostrar && menusMostrar.length > 0
        ? menusMostrar.map(menu => {
            if (menu.visible === 'S' && menu.objeto_programa === 'USUARIO') {
              menu.hijos.sort(ordenarMenu)
            }
            return menu.visible === 'S' && menu.objeto_programa === 'USUARIO' && !invitado ? (
              <div
                key='boton_usuario'
                className='tt-desctop-parent-account tt-parent-box'>
                <div className='tt-account tt-dropdown-obj'>
                  <button
                    className='tt-dropdown-toggle mi-cuenta'
                    data-tposition='bottom'>
                    {menu.icono ? cargarIcono(menu) : ''}{' '}
                    <small>{isAuthenticated ? user.usuario_web : ''}</small>
                  </button>
                  <div className='tt-dropdown-menu sub-mi-cuenta'>
                    <div className='tt-mobile-add'>
                      <button className='tt-close'>{i18n.t('general.cerrar')}</button>
                    </div>
                    <div className='tt-dropdown-inner'>
                      <ul>
                        {menu.hijos.map(hijo => {
                          return hijo.visible === 'S' ? (
                            <li key={hijo.id}>
                              <Link to={'/' + hijo.programa}>
                                {cargarIcono(hijo)}
                                {hijo.nombre}
                              </Link>
                            </li>
                          ) : (
                            ''
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )
          })
        : ''}
    </div>
  )

  return (
    <header id='cabecera-principal'>
      <nav className='panel-menu mobile-main-menu'>
        <div className='mm-navbtn-names'>
          <div
            className='mm-closebtn'
            style={{ marginTop: '5px', marginRight: '5px' }}>
            <X
              size={16}
              weight='bold'
            />
          </div>
        </div>
        {mobileMenu}
      </nav>
      <div className='tt-mobile-header'>
        <div className='container-fluid'>
          <div className='tt-header-row'>
            <div className='tt-mobile-parent-menu'>
              <div className='tt-menu-toggle'>
                <i className='icon-03'></i>
              </div>
            </div>
            <div className='tt-mobile-parent-cart tt-parent-box'></div>
            <div className='tt-mobile-parent-account tt-parent-box'></div>
          </div>
        </div>
        <div className='container-fluid tt-top-line'>
          <div className='row'>
            <div className='tt-logo-container'>
              <Link
                to={'/'}
                className='tt-logo tt-logo-alignment'>
                {portal.logo ? (
                  <img
                    src={'data:image/png;base64, ' + portal.logo}
                    alt=''
                    className='loading'
                    data-was-processed='true'
                  />
                ) : (
                  <span className='tt-title'>{portal.descripcion}</span>
                )}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className='tt-desktop-header'>
        <div className='tt-color-scheme-01'>
          <div className='container-fluid'>
            <div className='tt-header-holder'>
              <div className='tt-obj-logo'>
                <Link
                  to={'/'}
                  className='tt-logo tt-logo-alignment'>
                  {portal.logo ? (
                    <img
                      src={'data:image/png;base64, ' + portal.logo}
                      alt=''
                      className='loading'
                      data-was-processed='true'
                    />
                  ) : (
                    <span className='tt-title'>{portal.descripcion}</span>
                  )}
                </Link>
              </div>
              <LanguageSelector />
              {desktoLinks}
              {desktopAuthObjects}
            </div>
          </div>
        </div>
      </div>
      <div className='tt-stuck-nav'>
        <div className='container'>
          <div className='tt-header-row '>
            <div className='tt-stuck-parent-menu'></div>
            <div className='tt-stuck-parent-search tt-parent-box'></div>
            <div className='tt-stuck-parent-cart tt-parent-box'></div>
            <div className='tt-stuck-parent-account tt-parent-box'></div>
            <div className='tt-stuck-parent-multi tt-parent-box'></div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
